import { useQueryParams } from '@elentari/core'
import { useEffect } from 'react'
import snackbarStore from 'src/stores/snackbar'
import { getAuthorizations } from 'src/utils/crudAuthorization'
import { useAbility } from '../login'
import { paisesRepository } from './hooks/paisesRepository'
import { PaisesFilter, PaisQueryFilter } from './PaisFilter'
import { PaisesTable } from './PaisTable'
import { paisesStore } from './stores'

const Paises = () => {
  const { initialValues } = useQueryParams<PaisQueryFilter>()

  const ability = useAbility()

  async function handleDelete(id: string) {
    const response = await paisesRepository.delete(id)
    paisesStore.paises.populate()

    if (response.ok) {
      snackbarStore.setMessage('Deletado com Sucesso')
      return
    }

    const message = (response.data as unknown as any).message
    snackbarStore.setMessage(message as string)
  }

  useEffect(() => {
    paisesStore.paises.setPage(Number(initialValues.page) || 1)
    paisesStore.paises.setFilters(initialValues)
  }, [initialValues]) // eslint-disable-line

  const authorization = getAuthorizations(ability, 'Países')

  return (
    <>
      <PaisesFilter />
      <PaisesTable onDelete={handleDelete} authorization={authorization} />
    </>
  )
}

export default Paises
